import cn from "classnames";
import Styles from "../Icon.module.scss";
import { IconProps, IconSizes } from "../icon-prop-types";

export const NoResponseIcon = ({
  stroke = "white",
  fill = "gcBlue",
  size = "xsmall",
}: IconProps) => {
  const fillStyles = cn(Styles[fill], Styles.fill);
  const strokeStyles = cn(Styles[stroke], Styles.fill);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      viewBox="0 0 15 15"
      height={IconSizes[size]}
      width={IconSizes[size]}
      role="img"
    >
      <title>No Response</title>
      <defs>
        <circle className={fillStyles} id="noResponsea" cx="7" cy="7" r="6" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(-753 -403)">
          <g transform="translate(337 387)">
            <g transform="translate(.66)">
              <g transform="translate(330.33 12)">
                <g transform="translate(76)">
                  <g transform="translate(10 4.5)">
                    <g transform="translate(1 1)">
                      <mask id="noResponseb" className={strokeStyles}>
                        <use xlinkHref="#noResponsea" />
                      </mask>
                      <use fill="#059BFC" xlinkHref="#noResponsea" />
                      <g fill="#0070C8" mask="url(#noResponseb)">
                        <g transform="translate(1 1)">
                          <rect width="12" height="12" />
                        </g>
                      </g>
                      <circle cx="7" cy="7" r="6.5" className={fillStyles} />
                      <path
                        d="m4.5 5.2093h1.2694c0.043214-0.65901 0.49156-1.0804 1.1884-1.0804 0.68062 0 1.1344 0.40513 1.1344 0.96691 0 0.53477-0.22687 0.82107-0.89669 1.2262-0.74544 0.43754-1.0587 0.9237-1.0101 1.734l0.0054018 0.36732h1.2532v-0.3079c0-0.53477 0.19986-0.81026 0.90749-1.2262 0.73464-0.43754 1.1452-1.0155 1.1452-1.842 0-1.1938-0.98852-2.0473-2.4686-2.0473-1.6043 0-2.4848 0.9291-2.528 2.2093zm2.3768 5.7907c0.55098 0 0.89669-0.34031 0.89669-0.85888 0-0.52397-0.34571-0.86428-0.89669-0.86428-0.54018 0-0.89669 0.34031-0.89669 0.86428 0 0.51857 0.35652 0.85888 0.89669 0.85888z"
                        className={strokeStyles}
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
export default NoResponseIcon;
